module.exports = __webpack_public_path__ + "static/img/onlinebottom.2cde2a1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/image/we/onlinebottom.png
 ** module id = 596
 ** module chunks = 2
 **/